import keycloak from '../keycloak'

const MARGEM_RENOVACAO_TOKEN_SEGUNDOS = 30

/**
 * Devolve o token do usuário autenticado no Keycloak. A API identifica o fornecedor
 * pelos claims `code` e `isFornecedor`, que só existem nesse token — um token de
 * client_credentials chega sem eles e a requisição é recusada.
 */
export async function getTokenFromKeycloak(): Promise<string> {
    if (!keycloak.authenticated) {
        throw new Error('Sessão do usuário não iniciada no Keycloak.')
    }

    await keycloak.updateToken(MARGEM_RENOVACAO_TOKEN_SEGUNDOS)

    if (!keycloak.token) {
        throw new Error('Keycloak não devolveu um token de acesso.')
    }

    return keycloak.token
}
